module.exports = __webpack_public_path__ + "img/8f10924.png";